import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableContainer from '@material-ui/core/TableContainer';
import TableRow from '@material-ui/core/TableRow';
import ShareReportTableRow from './ShareReportTableRow';
import ShareReportTableHead from './ShareReportTableHead';
import ShareReportTableCell from './ShareReportTableCell';
import ShareReportTableMenu from './ShareReportTableMenu';
import ShareReportActionsDialog from './ShareReportActionsDialog';
import ShareAction from '../../../../../enums/ShareAction';

const useStyles = makeStyles((theme) => ({
  table: {
    minWidth: 750,
    marginBottom: theme.spacing(2),
  },
}));

function ShareReportTable({
  type,
  selected = [],
  setSelected,
  data = [],
  handleSendEmail,
  handleRemoveAccess,
  sharedAndInheritedData,
}) {
  const classes = useStyles();
  const [order, setOrder] = useState('asc');
  const [orderBy, setOrderBy] = useState('email');
  const [rowMenu, setRowMenu] = useState({});
  const [actionsDialogOpen, setActionsDialogOpen] = useState('');

  const clearState = () => {
    setRowMenu({});
    setActionsDialogOpen('');
  }

  const descendingComparator = (a, b, orderBy) => {
    if (orderBy === 'lastSent') {
      if (new Date(b[orderBy]) < new Date(a[orderBy])) return -1;
      if (new Date(b[orderBy]) > new Date(a[orderBy])) return 1;
      return 0;
    } else {
      if (b[orderBy] < a[orderBy]) return -1;
      if (b[orderBy] > a[orderBy]) return 1;
      return 0;
    }
  }

  const getComparator = (order, orderBy) => {
    return order === 'desc'
      ? (a, b) => descendingComparator(a, b, orderBy)
      : (a, b) => -descendingComparator(a, b, orderBy);
  }

  const stableSort = (array, comparator) => {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
      const order = comparator(a[0], b[0]);
      if (order !== 0) return order;
      return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
  }

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = data && data.map((n) => n.email);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleCloseMenu = event => {
    event.stopPropagation();
    setRowMenu({});
  };
  
  const handleSelectMenuItem = (event, option) => {
    event.stopPropagation();
    if (option.display === ShareAction.RESEND) {
      setActionsDialogOpen(ShareAction.RESEND);
    } else if (option.display === ShareAction.REMOVE) {
      setActionsDialogOpen(ShareAction.REMOVE);
    }
    setRowMenu(prevState => ({ ...prevState, anchorEl: null }))
  }

  const handleCloseActionsDialog = event => {
    setRowMenu({});
    setActionsDialogOpen('');
  }

  const isSelected = (email) => selected.indexOf(email) !== -1;

  return (
    <TableContainer>
      <Table className={classes.table} padding="none">
        <ShareReportTableHead
          classes={classes}
          tableType={type}
          numSelected={selected.length}
          order={order}
          orderBy={orderBy}
          onSelectAllClick={handleSelectAllClick}
          onRequestSort={handleRequestSort}
          rowCount={data.length}
        />
        <TableBody>
          {stableSort(data, getComparator(order, orderBy))
            .map((row, index) => {
              const isItemSelected = isSelected(row.email);
              return (
                <ShareReportTableRow 
                  key={`${row.email}-${index}`}
                  row={row} 
                  index={index} 
                  setSelected={setSelected} 
                  isItemSelected={isItemSelected} 
                  setRowMenu={setRowMenu}
                />
              );
            })}
          <TableRow>
            <ShareReportTableCell colSpan={6} />
          </TableRow>
        </TableBody>
      </Table>
      <ShareReportTableMenu
        tableType={type}
        rowMenu={rowMenu}
        onClickMenuItem={handleSelectMenuItem}
        onCloseMenu={handleCloseMenu}
      />
      {rowMenu.email && (
        <ShareReportActionsDialog 
          type={actionsDialogOpen} 
          emails={[rowMenu.email]}
          sharedAndInherited={sharedAndInheritedData.map(obj => obj.email)}
          handleConfirm={actionsDialogOpen === ShareAction.RESEND ? handleSendEmail : handleRemoveAccess} 
          handleCancel={handleCloseActionsDialog}
          successCallback={clearState}
        />
      )}
    </TableContainer>
  );
}

ShareReportTable.propTypes = {
  type: PropTypes.string.isRequired,
  selected: PropTypes.array,
  setSelected: PropTypes.func,
  data: PropTypes.array.isRequired,
  handleSendEmail: PropTypes.func.isRequired,
  handleRemoveAccess: PropTypes.func.isRequired,
  sharedAndInheritedData: PropTypes.array.isRequired,
}

export default ShareReportTable;


// WEBPACK FOOTER //
// ./src/components/SRHHeaders/SummaryReportHeader/components/ShareReport/components/ShareReportTable.jsx